import {IOneAnimeJson, IOneAnimeSmallJson, IUserAnimeInfo} from "../../../../nodeserver/structs/database";
import JSX from "../helpers/react.js";
import {favoriteTypes, posterSizes} from "../config.js";


const FavoriteIcon = ({list}: {list: IUserAnimeInfo['list']|undefined}) => {
    if (list?.is_fav) {
        return <span className="list favorite"><i className={["fa", favoriteTypes.find(e=>e.id==4)!.icon]} /></span>;
    } else if (list?.list) {
        return <span className={[favoriteTypes.find(e=>e.id === list.list?.id)?.icon??'', 'list', favoriteTypes.find(e=>e.id === list.list?.id)?.class??'']}><i className={["fa", favoriteTypes.find(e=>e.id === list.list?.id)?.icon??'']} /></span>;
    }
    return <></>;
};
function AnimeRating({anime}: {anime: IOneAnimeSmallJson}){
    if(!anime.rating?.average || anime.anime_status.alias === 'announcement') return <></>;
    return (
        <span className="rating-over">
            <span className="rating-info" title={anime.title} data-id={anime.anime_id}>
                <span className="fa fa-star" data-modal="rating-modal" style="color: white;"></span>
                <span className="main-rating materiable">{(anime.rating!.average).toFixed(2)}</span>
            </span>
        </span>

    );
}
function RatingBottom({anime}: {anime: IOneAnimeSmallJson}){
    if(!anime.rating?.average || anime.anime_status.alias === 'announcement') return <></>;
    return (<div className="rating-bottom">
        <div
            className="rating-info"
            title={anime.title}
            data-id={anime.anime_id}
        >
            <span className="fa fa-star rating-star" data-modal="rating-modal"></span>
            <span className="main-rating materiable">{anime.rating.average.toFixed(2)}</span>
        </div>
    </div>
    );

}
function ViewsCount({views}: {views: number}){
    return (
        <div title="Количество просмотров" className="views-count">
            <i className="fa fa-eye" />
            {views.toLocaleString('ru-RU')}
        </div>
    )
}
function VotesCount({anime}: {anime: IOneAnimeSmallJson}){
    if(anime.anime_status.alias === "announcement" || !anime.rating?.counters) return <></>;
    return (
        <div title="Количество голосов">
            <i className="fa fa-star" />
            {anime.rating.counters.toLocaleString('ru-RU')}
        </div>
    )
}
export default function AnimeColumn ({ anime }: {anime: IOneAnimeSmallJson}) {
    const animeHref = `/catalog/item/${anime.anime_url}`;
    return (
        <div className='anime-column' data-anime-id={anime.anime_id}>

            <a className="image-block" href={animeHref}>
                <AnimeRating anime={anime} />
                <img
                    src={anime.poster.big}
                    loading="lazy"
                    alt="Постер"
                    srcSet={`${anime.poster.medium} 184w, ${anime.poster.big} 250w, ${anime.poster.huge} 400w`}
                    sizes={posterSizes}
                />
                <FavoriteIcon list={anime.user?.list} />
            </a>
            <div className="anime-column-info">
                <a className="anime-title" href={animeHref}>
                    {anime.title}
                </a>
                <div className="icons-row">
                    <ViewsCount views={anime.views} />
                    <VotesCount anime={anime} />
                </div>
            </div>
            <RatingBottom anime={anime}/>
        </div>
    );
};

